import React from "react";
import { useTheme, useMediaQuery, Typography, Box, Button, Container, Grid, makeStyles } from "@material-ui/core";
import { SwyftContactPhoneNumberLink, SwyftEmailLink } from "../../app/consts";
import { colors } from "swyft-react-core";
import { isMobile } from "react-device-detect";

const useStyles = makeStyles((theme) => ({
  button: {
    width: "90%",
    maxWidth: "17.5rem"
  },
  doubleButton: {
    '& [class*="Button-root"]': {
      minWidth: "10rem",
      padding: "6px 8px",
      width: "auto"
    }
  },
  mb: {
    [theme.breakpoints.up("md")]: {
      marginBottom: theme.spacing(3)
    }
  },
  halfimage: {
    objectFit: "cover",
    width: "100%",
    height: 280,
    [theme.breakpoints.up("md")]: {
      height: 236
    },
    [theme.breakpoints.up("lg")]: {
      height: 323
    }
  },
  alternate: {
    background: colors.alternate
  }
}));

export const QuotePackageQuery: React.FC = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up("md"));

  const packageQueryTextSection = (
    <React.Fragment>
      <Typography variant="h2" paragraph>
        Got a question?
      </Typography>
      <Typography variant="body1" paragraph>
        If you have a query about your package quote, let us answer it for you.
      </Typography>
      <Typography variant="body1" paragraph>
        You can message us or ring us directly.
      </Typography>
      {isMobile ? (
        <Box
          display="flex"
          justifyContent={isMd ? "left" : "space-evenly"}
          flexDirection={isMd ? "column" : "row"}
          className={classes.doubleButton}
        >
          <Button
            href={SwyftContactPhoneNumberLink}
            variant="contained"
            color="secondary"
            className={`${classes.button} ${classes.mb}`}
          >
            Call us Today
          </Button>
        </Box>
      ) : (
        <Box>
          <Box mb={2}>
            <Button href={SwyftEmailLink} variant="contained" color="secondary" className={classes.button}>
              Email Us
            </Button>
          </Box>
          <Typography variant="body1" gutterBottom>
            Phone us on
          </Typography>
          <Box textAlign="center" maxWidth="17.5rem">
            <Typography variant="h4" gutterBottom>
              Cork: (021) 701 1238
            </Typography>
            <Typography variant="h4" gutterBottom>
              Dublin: (01) 504 2111
            </Typography>
          </Box>
        </Box>
      )}
    </React.Fragment>
  );

  return isMd ? (
    <Box pt={3}>
      <Container maxWidth="lg">
        <Grid container spacing={3}>
          <Grid item md={6}>
            {packageQueryTextSection}
          </Grid>
          <Grid item md={6}>
            <img
              src={process.env.PUBLIC_URL + "/images/banners/Banner_SwyftTeam.jpg"}
              alt="Package Query"
              className={classes.halfimage}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  ) : (
    <Box>
      <img
        src={process.env.PUBLIC_URL + "/images/banners/Banner_SwyftTeam.jpg"}
        alt="Package Query"
        className={classes.halfimage}
      />
      <Container maxWidth="lg">
        <Box pt={2}>{packageQueryTextSection}</Box>
      </Container>
    </Box>
  );
};
